<template>
  <div>
    <v-card outlined class="pa-2">
        <v-card-text>
            <v-card elevation="2" :color="color" class="icon-container d-flex align-items-center justify-content-center" rounded 
              style="height: 5vw;width: 5vw;top: 0;position: absolute;margin-top: -20px; min-width: 40px; min-height: 40px;">
                <!-- <v-icon size="1.6vw" color="white">{{headerIcon}}</v-icon> -->
                <v-icon color="white" style="font-size:calc(12px + 1.5vw)">{{headerIcon}}</v-icon>
            </v-card>
            <div class="text-right mb-4">
                {{description}}
                <h3 class="highlight-text">{{value}}</h3>
            </div>
            <v-divider></v-divider>
            <div class="row align-self-center"><v-icon small class="ml-5 mr-2">fas fa-external-link-alt</v-icon><span class="no-highlight-text"><a @click="linkClicked()">{{ $t("show_theses") }}</a></span></div>
        </v-card-text>
    </v-card>
  </div>
  
</template>

<script>
export default {
  

  props: {
        color: String,
        headerIcon: String,
        description: String,
        externalLink: String,
        value: Number
    },

  data() {
    return {
        // keycard:{
        //     color: "green",
        //     icon: "fas fa-home",
        // }
    }
  },

  methods: {
    linkClicked(){
      this.$emit("fetchTheses", this.externalLink);
    },
  }
}
</script>

<style scoped>
  .icon-container{
      position: absolute;
      top: 0;
      margin-top: -20px;
      height: 5vw;
      width: 5vw;
  }
</style>